"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const material_1 = require("@mui/material");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
function Alert(_a) {
    var { type = "error", small, children } = _a, rest = __rest(_a, ["type", "small", "children"]);
    return (react_1.default.createElement(Wrapper, Object.assign({ type: type, small: small, marginBottom: "S" }, rest),
        react_1.default.createElement(material_1.Alert, { severity: type }, children)));
}
exports.default = Alert;
const Wrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  ${base_ui_components_atoms__atoms_1.common}

  .MuiPaper-root {
    align-items: center;
  }

  .MuiAlert-icon {
    padding: 0;
    font-size: ${({ theme }) => theme.font.L};
  }

  .MuiAlert-message {
    font-weight: ${({ theme }) => theme.font.normal};
    font-size: ${({ theme }) => theme.font.M};
  }

  a {
    text-decoration: underline;
  }

  ${({ small }) => small &&
    (0, styled_components_1.css) `
      .MuiAlert-message {
        padding: 3px 0;
        font-size: ${({ theme }) => theme.font.S};
      }
    `};

  .MuiAlert-message,
  .MuiAlert-icon {
    ${({ theme, type }) => type === "error" &&
    (0, styled_components_1.css) `
        color: ${theme.color.red} !important;
      `};

    ${({ theme, type }) => type === "warning" &&
    (0, styled_components_1.css) `
        color: ${theme.color.orange} !important;
      `};

    ${({ theme, type }) => type === "success" &&
    (0, styled_components_1.css) `
        color: ${theme.color.green} !important;
      `};
  }
`;
//# sourceMappingURL=Alert.js.map